<template>
<div class="chapter">
<div class="inner_page">
<p class="image-center_po"><img alt="image" class="svg" src="Backed/img/portalistlogo.png"/></p>
<p class="end-title_po">The Galaxy’s Greatest Newsletter<br/>Delivered to Your Inbox</p>
<p class="end-title_po1">Get awesome tales of fantasy and science fiction once a week.</p>
<p class="image-center_po1"><a href="https://theportalist.com/newsletters/?utm_source=PORGOAAAAJ&amp;utm_campaign=9781504037358" target="_blank"><img alt="image" class="svg" src="Backed/img/pro-signup.jpg"/></a></p>
<p class="end-title_po2">Visit us at <a href="https://theportalist.com/newsletters/?utm_source=PORGOAAAAJ&amp;utm_campaign=9781504037358" target="_blank"><span class="Hyperlink">www.theportalist.com</span></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// portalistad_1.vue?1015c762